import { useFetchAvailableAuthMethodQuery } from "../../Redux/Service/methodsApi";
import type { IMethodsList } from "./utils";
import { getAvailableMethods } from "./utils";

export interface IAuthenticateMethods {
  methods: IMethodsList[];
  isLoading: boolean;
}

export const useAuthentication = (): IAuthenticateMethods => {
  const { data, isLoading } = useFetchAvailableAuthMethodQuery({});

  return {
    methods: getAvailableMethods(data?.data),
    isLoading,
  };
};
